module.exports = __webpack_public_path__ + "static/media/Icon1-1.39f75dc9.png";